module.exports = __webpack_public_path__ + "img/NoPath.0781f648.jpg";